import microOrgs from '@/sui/data/microOrgs'
import common from '@/components/sheets/import/impl/common'

function getMicroOrganisms (o, virus) {
  let ms = []
  const list = virus ? microOrgs.completeList.v2 : microOrgs.list.v2
  for (let i = 1; i !== 5; i++) {
    let m = getMicroOrganism(o, o[`mo${i}`], i, list)
    if (m != null) {
      ms.push(m)
    }
  }
  return ms
}

function getMicroCode (code, list) {
  const c = code.indexOf(' ') !== 3
    ? `${code.slice(0, 3)} ${code.slice(3, 6)}` : code
  const m = list.find((m) => m.code === c)
  return m != null ? m.index : null
}

function getMicroOrganism (o, code, n, list) {
  if (code == null || code.length === 0) {
    return null
  }

  const microCode = getMicroCode(code, list)
  if (microCode == null) {
    throw new Error(`Micro organisme inconnu : ${code} !`)
  }

  let rlist = []
  const resistances = o[`resist${n}`]
  if (resistances != null) {
    const split = resistances.split(' ')
    split.forEach(
      (s) => {
        const v = s.split('=')
        if (v.length === 2) {
          const field = v[0].toLowerCase()
          const resistance = microOrgs.resistances.v2.find(
            r => r.field === field
          )
          if (resistance != null) {
            const value = resistance.values.find(
              i => i.code === v[1] || i.alt === v[1]
            )
            if (value != null) {
              rlist.push(
                {
                  code: resistance.index,
                  resistance: value.index
                }
              )
            }
          }
        }
      }
    )
  } else {
    microOrgs.resistances.forEach(
      (r) => {
        const v = o[`bact${r.field}${n}`]
        if (v != null && v !== '') {
          const value = r.values.find(
            i => i.code === v || i.alt === v
          )
          if (value != null) {
            rlist.push(
              {
                code: r.index,
                resistance: value.index
              }
            )
          }
        }
      }
    )
  }

  const moDetailField = o[`microOrgDetail${n}`]
  const moDetail = common.nullIfEmpty(moDetailField != null ? moDetailField.trim() : null)
  return { code: microCode, antibio: rlist, microOrgDetail: moDetail }
}

function getOrigin (p) {
  if (p.unitType.startsWith('NEO')) {
    return common.getValue(p.neoOrigin, [1, 2, 3, 4, 5, 6, 9])
  }

  return common.getValue(p.origin, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
}

function createSheet (year, p) {
  const sheet = {
    sheetNumber: p.sheetNumber,
    unitType: common.getUnitTypeCode(year, p.unitType),
    uf: p.uf != null ? p.uf.toString() : null,
    birthdate: common.newDate(p.birthdate),
    sex: common.getValue(p.sex, [1, 2, 3, 9]),
    entry: common.newDate(p.entry),
    immuno: common.getValue(p.immuno, [1, 2, 3, 9]),
    cancer: common.getValue(p.cancer, [1, 2, 3, 9]),
    origin: getOrigin(p),
    bmi: common.nullIfEmpty(p.bmi),
    birthWeight: common.nullIfEmpty(p.birthWeight),
    gestationalAge: common.nullIfEmpty(p.gestationalAge),
    dead: common.getValue(p.dead, [1, 2, 9]),
    death: common.newDate(p.death),
    bacteremia: {
      present: 1,
      episod: common.newDate(p.episod),
      diagDate: common.newDate(p.diagDate),
      origin: common.getValue(p.bactOrigin, [1, 2, 3, 4, 5, 9], null),
      covidStatus: common.getValue(p.covid, [1, 2, 3, 9]),
      episodImmuno: common.getValue(p.episodImmuno, [1, 2, 3, 9]),
      entrance_v2: common.getValue(
        p.entrance,
        [
          'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11',
          'C12', 'C13', 'C14', 'D1', 'D2', 'D3', 'D4', 'A1', 'A2', 'A3', 'A4',
          'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13'
        ]
      ),
      insertion: (p.insertion != null && p.insertion !== '')
        ? common.newDate(p.insertion)
        : common.newDate(p.catheterDate),
      previousManip: common.getValue(p.previousManip, [1, 2, 9]),
      previousManipType: common.getValue(p.previousManipType, [1, 2, 3, 9]),
      previousManipDate: common.newDate(p.previousManipDate),
      insertionSite: common.getValue(p.insertionSite, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
      removed: common.getValue(p.removed, [1, 2, 9]),
      removal: common.newDate(p.removal),
      divDiag: common.getValue(p.divDiag, [1, 2, 3, 4, 5, 9]),
      clinicalSigns: common.getValue(p.clinicalSigns, [1, 2, 9]),
      bioSigns: common.getValue(p.bioSigns, [1, 2, 9]),
      adaptedAntibio: common.getValue(p.adaptedAntibio, [1, 2, 9]),
      twoHemocs: common.getValue(p.twoHemocs, [1, 2, 9]),
      lipids: common.getValue(p.lipids, [1, 2, 9]),
      tunneled: common.getValue(p.tunneled, [1, 2, 9]),
      bactintubated: common.getValue(p.bactintubated, [1, 2, 9]),
      bactintubStart: common.newDate(p.bactintubStart),
      bactreintubated: common.getValue(p.bactreintubated, [1, 2, 9]),
      bactintubEnd: common.newDate(p.bactintubEnd),
      urinary: common.getValue(p.urinary, [1, 2, 3, 9]),
      urinary_v2: common.getValue(p.urinary_v2, [1, 2, 3, 4, 5, 6, 9]),
      urinaryStart: common.newDate(p.urinaryStart),
      urinaryRemoved: common.getValue(p.urinaryRemoved, [1, 2, 9]),
      urinaryEnd: common.newDate(p.urinaryEnd),
      urinaryDiag: common.getValue(p.urinaryDiag, [1, 9]),
      catheter: common.getValue(p.catheter, [1, 2, 9]),
      catheterType_v2: common.getValue(
        p.catheterType, [
          'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11',
          'C12', 'C13', 'C14', 'D1'
        ]
      ),
      enfPreviousManip: common.getValue(p.enfPreviousManip, [1, 2, 9]),
      enfPreviousManipType: common.getValue(p.enfPreviousManipType, [1, 2, 3, 9]),
      enfPreviousManipDate: common.newDate(p.enfPreviousManipDate),
      enfTunneled: common.getValue(p.enfTunneled, [1, 2, 9]),
      microOrganisms: getMicroOrganisms(p, false)
    }
  }

  common.checkMissingColumns(sheet)

  return sheet
}

export default {
  createSheet: createSheet
}
